<template>
    <div class="buying-list-item__favorite" @click="changeStatus">
        <i :class="'fa ' + (this.favoriteId ? 'fa-heart' : 'fa-heart-o')"></i>
        Избранное
    </div>
</template>

<script>
    import IsFavoriteService from "../services/IsFavoriteService";

    const COMPONENT_NAME = 'is-favorite';

    export default {
        name: COMPONENT_NAME,
        props: {
            favoriteId: {
                currentValue: null
            },
            ancestorId: {},
            attributesAndValues: {}
        },
        methods: {
            async changeStatus() {
                if (this.favoriteId) {
                    let response = await IsFavoriteService.remove(this.favoriteId);
                    if (response.success) {
                        var text = this.$createElement('span', 'Товар удален из избранного');

                        this.favoriteId = null;
                    }
                } else {
                    let response = await IsFavoriteService.add(this.ancestorId, JSON.parse(this.attributesAndValues));
                    if (response.success) {
                        var text = this.$createElement('span', 'Товар добавлен в избранное');


                        this.favoriteId = response.favorite.id;
                    }
                }
                if (text) {
                    let message = this.$createElement('div', [
                        text
                    ]);

                    this.$notify({message: message, type: 'success'});
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>